import script from "./OfficeWidgets.vue?vue&type=script&setup=true&lang=js"
export * from "./OfficeWidgets.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__